<ui-dialog
    size="small"
    header="{{
        {
            key: 'time-off-v3.timeOffTypeNameDetails',
            params: { timeOffTypeName: selectedTimeOffTypeAndPolicyWithBalance?.timeOffType.name },
        } | appTranslate
    }}"
    [open]="isTimeOffTypeDetailsOpen"
    (closing)="isTimeOffTypeDetailsOpen = false; timeOffTypeDetails.closeExpansionPanel()"
    scrollable="true"
>
    <app-time-off-type-details #timeOffTypeDetails [employee]="employee"></app-time-off-type-details>
    <ui-dialog-footer>
        <ui-button
            type="primary"
            (click)="isTimeOffTypeDetailsOpen = false; timeOffTypeDetails.closeExpansionPanel()"
            >{{ 'done' | translate }}</ui-button
        >
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    [open]="showCalculateBalanceModal"
    (primaryButtonPressed)="onClose()"
    primaryButtonLabel="Done"
    (secondaryButtonPressed)="onClose()"
    (closing)="onClose()"
    secondaryButtonLabel="Cancel"
    [form]="calculateBalanceForm.form"
    size="small"
    header="time-off-v3.calculateBalance"
>
    <app-calculate-balance-form
        [employeeId]="this.employee.id"
        [timeOffTypes]="timeOffTypes"
        #calculateBalanceForm
    ></app-calculate-balance-form>
</ui-dialog>

<app-deprecated-modal-form
    #adjustmentModal
    [form]="adjustmentForm"
    headerText="time-off-v3.makeAdjustment"
    (save)="onSaveAdjustment()"
    [customHeight]="modalHeight"
>
    <app-adjustment-form [timeOffTypes]="timeOffTypes" [employeeId]="employee.id" #adjustmentForm></app-adjustment-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #changePolicyModal
    [isLoading]="isLoading"
    [form]="changePolicyForm"
    headerText="time-off-v3.changePolicy"
    (save)="onSaveChangePolicy(changePolicyForm)"
    [customHeight]="modalHeight"
>
    <app-change-policy #changePolicyForm></app-change-policy>
</app-deprecated-modal-form>

<ui-confirmation-dialog
    #deleteTransactionModal
    [primaryButtonLabel]="'delete' | translate"
    [primaryButtonType]="'danger'"
    [header]="'Delete Adjustment'"
>
    <div class="content">{{ 'time-off-v3.areYouSureYouWantToMakeThisAdjustment' | translate }}</div>
</ui-confirmation-dialog>

<ui-dialog
    size="small"
    header="time-off-v3.confirmErase"
    [primaryButtonLabel]="'time-off-v3.eraseAccruals' | translate"
    [secondaryButtonLabel]="'cancel' | translate"
    deleteDialog
    [open]="showEraseAccrualConfirmation"
    (primaryButtonPressed)="eraseAccruals()"
    (secondaryButtonPressed)="showEraseAccrualConfirmation = false"
    (closing)="showEraseAccrualConfirmation = false"
>
    <p
        [innerHTML]="
            {
                key: 'time-off-v3.allAccrualsWillBeDeleted',
                params: {
                    timeOffTypeName: selectedTimeOffTypeAndPolicyWithBalance?.timeOffType.name,
                    employeeName: employee?.fullName,
                },
            }
                | appTranslate
                | sanitizeHtml
        "
    ></p>

    <p [innerHTML]="'time-off-v3.requestsAndManualAdjustmentsWillNotBeDeleted' | translate"></p>
    <p>{{ 'time-off-v3.youCanReassignThisEmployeeToAPolicy' | translate }}</p>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event" [terminateUrl]="['../', 'terminate']">
        <div class="timeOff" *ngIf="hasTypesAssigned">
            <ui-button type="primary" (click)="onClick()">{{ 'time-off-v3.recordTimeOff' | translate }}</ui-button>
        </div>
    </app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            <app-empty-state
                label="{{ 'time-off-v3.noTimeOffTypesCurrentlyAssignedInclCurrently' | translate }}"
                src="/assets/illustrations/empty-box.png"
                *ngIf="!hasTypesAssigned; else hasTypes"
            ></app-empty-state>

            <ng-template #hasTypes>
                <div class="app-grid">
                    <ng-container *ngFor="let timeOffTypeAndPolicyWithBalance of timeOffTypeAndPolicyWithBalances">
                        <app-time-off-policy-card
                            [color]="
                                timeOffTypeAndPolicyWithBalance.timeOffPolicy?.isFuture
                                    ? 'var(--grey-800)'
                                    : timeOffTypeAndPolicyWithBalance.timeOffType.color
                            "
                            [attr.name]="timeOffTypeAndPolicyWithBalance.timeOffType.name"
                            [timeOffTypeName]="timeOffTypeAndPolicyWithBalance.timeOffType.name"
                            [unitOfTime]="getUnitOfTime(timeOffTypeAndPolicyWithBalance.timeOffType)"
                            [isUnlimited]="timeOffTypeAndPolicyWithBalance.timeOffPolicy.isUnlimited"
                            [amount]="getBalanceAmount(timeOffTypeAndPolicyWithBalance)"
                            [icon]="timeOffTypeAndPolicyWithBalance.timeOffType.icon"
                            [balanceDateSetting]="balanceDateSetting"
                            [balanceDateLabel]="timeOffTypeAndPolicyWithBalance.timeOffBalance.balanceDateLabel"
                            [timeOffPolicy]="timeOffTypeAndPolicyWithBalance.timeOffPolicy"
                            [isAdmin]="viewerIsAdmin"
                            class="columns-4 large-columns-6 small-columns-12 margin-bottom-3"
                        >
                            <app-context-item
                                label="time-off-v3.calculateBalance"
                                (click)="
                                    viewCalculateBalanceModal(
                                        timeOffTypeAndPolicyWithBalance.timeOffType.id,
                                        timeOffTypeAndPolicyWithBalance.timeOffPolicy.carryoverCap
                                    )
                                "
                                *ngIf="canCalculateBalance(timeOffTypeAndPolicyWithBalance)"
                            ></app-context-item>
                            <app-context-item
                                label="time-off-v3.makeAdjustment"
                                (click)="viewAdjustment(timeOffTypeAndPolicyWithBalance)"
                                *ngIf="
                                    viewerIsAdmin &&
                                    !timeOffTypeAndPolicyWithBalance.timeOffPolicy.isUnlimited &&
                                    !timeOffTypeAndPolicyWithBalance.timeOffPolicy?.isFuture
                                "
                            ></app-context-item>
                            <app-context-item
                                *ngIf="!timeOffTypeAndPolicyWithBalance.timeOffPolicy?.isFuture && this.viewerIsAdmin"
                                label="time-off-v3.changePolicy"
                                (click)="viewChangePolicy(timeOffTypeAndPolicyWithBalance.timeOffType.id)"
                            ></app-context-item>
                            <app-context-item
                                label="time-off-v3.eraseAccruals"
                                *ngIf="viewerIsAdmin && !timeOffTypeAndPolicyWithBalance.timeOffPolicy?.isFuture"
                                (click)="showEraseAccrualsDialog(timeOffTypeAndPolicyWithBalance)"
                            ></app-context-item>
                            <ui-button
                                type="outline"
                                class="view-details-button padding-top-3"
                                (click)="viewDetails(timeOffTypeAndPolicyWithBalance)"
                                >{{ 'time-off-v3.viewDetails' | translate }}</ui-button
                            >
                        </app-time-off-policy-card>
                    </ng-container>
                </div>
                <ui-card *permission="calendarPermission">
                    <app-year-calendar-v3
                        #calendar
                        title="time-off-v3.yearlyUsage"
                        [relatedEntities]="[employee]"
                        [eventTypes]="eventTypes"
                        [legend]="calendarLegend"
                    ></app-year-calendar-v3>
                </ui-card>
                <div class="table">
                    <app-table
                        [useStickyHeader]="false"
                        [showSearch]="false"
                        [table]="requestTable"
                        title="{{ 'time-off-v3.requests' | translate }}"
                    >
                        <app-empty-state
                            label="{{ 'time-off-v3.noRequestsFound' | translate }}"
                            src="/assets/illustrations/calendar.png"
                        ></app-empty-state>
                    </app-table>
                </div>
                <div>
                    <app-table
                        [useStickyHeader]="false"
                        [showSearch]="false"
                        [table]="transactionTable"
                        title="{{ 'time-off-v3.transactionsLog' | translate }}"
                        (menuItemSelected)="onMenuAction($event)"
                    >
                        <app-empty-state
                            [label]="getTransactionTableEmptyStateLabel() | appTranslate"
                            src="/assets/illustrations/calendar.png"
                        ></app-empty-state>
                    </app-table>
                </div>
            </ng-template>
        </div>
    </div>
</div>
